module.exports = __webpack_public_path__ + "static/img/cloud1.93c81d29.png";